var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-container",attrs:{"data-title":"使用:hover描绘鼠标跟随"}},[_c('ul',{staticClass:"mouse-following"},_vm._l((500),function(v){return _c('li',{key:v})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }